import React from 'react';
import StarField from './StarField';

const WorkshopInfoSection = () => {
  return (
    <section className="min-h-screen flex items-center justify-center bg-black relative overflow-hidden">
      <StarField density="sparse" />
      <div className="container mx-auto px-6 max-w-2xl relative z-10 text-center">
        <h1 className="text-5xl md:text-7xl font-light text-white mb-6 tracking-tight">
          Workshop Info
        </h1>
        <div className="w-20 h-1 bg-white mx-auto mb-8"></div>
        <p className="text-2xl md:text-3xl font-light text-gray-400 tracking-wide">
          Coming soon...
        </p>
      </div>
    </section>
  );
};

export default WorkshopInfoSection;
